/**
 * PostHog runtime configuration.
 *
 * NOTE — Lovable platform constraint:
 *   - Build Secrets are not available in this project/plan.
 *   - `VITE_*` env vars cannot be added as Lovable secrets.
 *   The PostHog Project API Key (`phc_...`) is **publishable by design**
 *   (PostHog documents it as safe to expose in the browser; access control
 *   lives in allowed origins + rate limits), so we hardcode it here in the
 *   same way the Supabase anon key lives in `src/integrations/supabase/client.ts`.
 *
 * >>> PASTE YOUR PROJECT API KEY ON THE NEXT LINE <<<
 * Replace the placeholder string with the value from:
 *   PostHog → Project Settings → Project API Key (starts with `phc_`).
 * Do not commit any other secret here.
 */
export const POSTHOG_KEY = "phc_xAZ6sJfsjQAB96RiNK62LkNKsRv2siAEzoo4wUB3PJsE";
export const POSTHOG_HOST = "https://us.i.posthog.com";

export function isPostHogConfigured(): boolean {
  return (
    typeof POSTHOG_KEY === "string" &&
    POSTHOG_KEY.startsWith("phc_") &&
    POSTHOG_KEY.length >= 30
  );
}